import type { ReactNode } from "react";
import { ThreadPrimitive } from "@assistant-ui/react";
import { Message } from "./ChatMessage";
import { MessageViewport } from "./messageBubbles";

interface ChatMessageListProps {
  header?: ReactNode;
}

export function ChatMessageList({ header }: ChatMessageListProps) {
  return (
    <ThreadPrimitive.Viewport asChild>
      <MessageViewport>
        {header}
        <ThreadPrimitive.Empty>
          <div />
        </ThreadPrimitive.Empty>
        <ThreadPrimitive.Messages
          components={{
            UserMessage: Message,
            AssistantMessage: Message,
          }}
        />
      </MessageViewport>
    </ThreadPrimitive.Viewport>
  );
}
